// Just for make jest happy!
import _ from 'lodash';

const BaseEnums = Object.freeze({
  FieldTypes: Object.freeze({
    DateOnly: 'date',
    DateTime: 'datetime',
    Email: 'email',
    LongText: 'long_text',
    Lookup: 'lookup',
    NumberInput: 'number',
    PickList: 'picklist',
    TextInput: 'text',
    // for display only field
    Display: 'display',
    // temp fix, should be removed if backend fix the problem, see more for Issue#55
    ApiError: 'apiError'
  }),

  ObjectTypes: Object.freeze({
    Dashboard: 'dashboard',
    Leads: 'leads',
    Accounts: 'accounts',
    Opportunities: 'opportunities',
    Reports: 'reports',
    Email: 'email'
  }),

  ThemeTypes: Object.freeze({
    Dashboard: 'dashboard',
    Leads: 'lead',
    Accounts: 'account',
    Opportunities: 'opport',
    Reports: 'report',
    Email: 'email',
    Setup: 'setup'
  }),

  DetailTools: Object.freeze({
    Convert: 'Convert',
    Delete: 'Delete',
    Sharing: 'Sharing',
    FindDuplicates: 'FindDuplicates',
    AttachAccount: 'AttachAccount'
  }),

  DetailModules: Object.freeze({
    Opportunities: 'Opportunities',
    TaskOpen: 'TaskOpen',
    TaskHistory: 'TaskHistory',
    EmailSent: 'EmailSent',
    Attachments: 'Attachments',
    Logs: 'Logs',
    Invoice: 'Invoice'
  }),

  DateTimeSubTypes: Object.freeze({
    SpecificDate: 'SpecificDate',
    Range: 'Range'
    // TODO: This is comment out right now, but will eventually added as a feature in future.
    // CustomRange: 'CustomRange',
  }),

  DateTimeRanges: Object.freeze({
    Today: 'TODAY',
    ThisWeek: 'THIS_WEEK',
    ThisMonth: 'THIS_MONTH'
  }),

  DateTimePeriodPrefixs: Object.freeze({
    Next: 'Next',
    Last: 'Last'
  }),

  DateTimePeriodTypes: Object.freeze({
    Days: 'Days',
    Weeks: 'Weeks',
    Months: 'Months'
  }),

  Conditions: Object.freeze({
    StartsWith: 'starts_with',
    Contains: 'contains',
    Equals: 'equals',
    NotEquals: 'not_equals',
    NotContains: 'not_contains',
    LessThan: 'less_than',
    GreaterThan: 'greater_than',
    LessOrEquals: 'less_or_equals',
    GreaterOrEquals: 'greater_or_equals',
    WithIn: 'within',
    IsNull: 'is_null',
    IsNotNull: 'is_not_null',
    HasRelation: 'has_relation'
  }),

  InvoiceItemsListColumns: Object.freeze({
    Action: 'action',
    Description: 'description',
    Code: 'code',
    Quantity: 'quantity',
    UnitPrice: 'unitPrice',
    Total: 'total'
  }),

  InvoiceSummaryColumns: Object.freeze({
    SDescription: 'sDescription',
    SAddition: 'sAddition',
    STotal: 'sTotal'
  }),

  InvoiceSummaryRows: Object.freeze({
    Subtotal: 'subtotal',
    Tax: 'tax',
    GrandTotal: 'grandTotal'
  }),

  REPORT_FORMATS: Object.freeze({
    SUMMARY: 'summary'
    // MATRIX: 'matrix', // available soon
  }),

  REPORT_FOLDER_TYPES: Object.freeze({
    REPORT: 'report',
    DASHBOARD: 'dashboard'
  })
});

const tableIntl = 'global.ui.table';

const EnumsManager = Object.freeze({
  // !!!deprecated, update in LocalStorageKeys pls
  LocalStorageKey: 'crmLoginUser',
  LocalStorageEmails: 'crmEmails',
  KeyTypes: Object.freeze({
    OwnerKey: 'ownership_id',
    CreatedDateKey: 'created_at',
    LastModifiedKey: 'last_modified_date',
    LastActivityKey: 'last_activity_datetime'
  }),
  LocalStorageKeys: Object.freeze({
    User: 'crmLoginUser',
    Email: 'crmEmails',
    Timezone: 'crmTimezone',
    LanguaegOfApp: 'crmAppLanguage',
    dashboardView: 'crmDashBoardView',
    RouteInfo: 'crmRouteInfo',
    crmPageInfo: 'crmPageInfo',
  }),

  PhantomId: '0000-0000',
  Recently: 'Recently',
  Today: 'Today',

  DefaultPageConfigs: Object.freeze({
    PageSizeSmall: 10,
    PageSize: 25,
    Options: ['10', '25', '50', '100', '200', '300']
  }),

  MonthsConfig: Object.freeze({
    Monthskeys: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Agu', 'Sep', 'Oct', 'Nov', 'Dec'],
  }),

  SearchMethodKeys: Object.freeze({
    Fuzzy: 'fuzzy',
    Phrase: 'phrase'
  }),

  // !!!deprecated, update in FieldTypes pls
  DataType: Object.freeze(['datepicker', 'timepicker', 'picklist']),

  ThemeTypes: BaseEnums.ThemeTypes,

  // Transfer to array will facilitate the proptypes checking by oneof and use JS array methods
  // The following xxInArray properties serve the same purpose like this one.
  ThemeTypesInArray: Object.freeze(_.values(BaseEnums.ThemeTypes)),

  SortOrders: Object.freeze({
    ascend: 'asc',
    descend: 'desc'
  }),

  FieldTypes: BaseEnums.FieldTypes,

  FieldTypesInArray: Object.freeze(_.values(BaseEnums.FieldTypes)),

  FieldOperationTypes: Object.freeze({
    Edit: 'edit',
    Delete: 'delete',
    Deactivate: 'deactivate'
  }),

  ObjectTypes: BaseEnums.ObjectTypes,
  TABLEMAXROWS: 15,

  ObjectTypesInArray: Object.freeze(_.values(BaseEnums.ObjectTypes)),

  ObjectTypesThemesMapping: Object.freeze({
    [BaseEnums.ObjectTypes.Dashboard]: BaseEnums.ThemeTypes.Dashboard,
    [BaseEnums.ObjectTypes.Leads]: BaseEnums.ThemeTypes.Leads,
    [BaseEnums.ObjectTypes.Accounts]: BaseEnums.ThemeTypes.Accounts,
    [BaseEnums.ObjectTypes.Opportunities]: BaseEnums.ThemeTypes.Opportunities,
    [BaseEnums.ObjectTypes.Reports]: BaseEnums.ThemeTypes.Reports,
    [BaseEnums.ObjectTypes.Email]: BaseEnums.ThemeTypes.Email
  }),

  // This is used to avoid conflicts and make each one become unique in global action types pool
  REDUX_ACTION_TYPE_PREFIX: Object.freeze({
    VIEWFILTER: 'VIEW_FILTER_',
    VIEWDETAILS: 'VIEW_DETAILS_',
    DUPLICATES: 'DUPLICATES_',
    MERGE: 'MERGE_',
    OBJECTLIST: 'OBJECTLIST_',
    OBJECTSHARE: 'OBJECTSHARE',
    OBJECTDETAILS: 'OBJECTDETAILS',
    CONVERSION: 'CONVERSION',
    INVOICE: 'INVOICE',
    CRITERIA: 'CRITERIA',
    REPORTS: 'REPORTS',
    REPORT: 'REPORT',
    META_DATA: 'META_DATA'
  }),

  ViewVisibilityIds: Object.freeze({
    Me: 1,
    GroupsAndUsers: 3
  }),

  RootTeamId: 0,

  NoTeamId: -1,

  DetailActions: Object.freeze([
    {
      key: 'convert',
      path: 'convert'
    },
    {
      key: 'delete',
      path: ''
    },
    {
      key: 'sharing',
      path: 'sharing'
    },
    {
      key: 'findDuplicates',
      path: 'find'
    }
  ]),

  AntdGridMax: 24,

  DetailTools: BaseEnums.DetailTools,
  DetailToolsByObjectType: {
    [BaseEnums.ObjectTypes.Leads]: {
      Convert: 'Convert',
      Delete: 'Delete',
      Sharing: 'Sharing',
      FindDuplicates: 'FindDuplicates',
    },
    [BaseEnums.ObjectTypes.Accounts]: {
      Delete: 'Delete',
      Sharing: 'Sharing'
    },
    [BaseEnums.ObjectTypes.Opportunities]: {
      Delete: 'Delete',
      AttachAccount: 'AttachAccount',
    }
  },

  DetailToolsInArray: Object.freeze(_.values(BaseEnums.DetailTools)),

  DetailModules: BaseEnums.DetailModules,
  DetailModulesByObjectType: {
    [BaseEnums.ObjectTypes.Leads]: {
      TaskOpen: 'TaskOpen',
      TaskHistory: 'TaskHistory',
      EmailSent: 'EmailSent',
      Attachments: 'Attachments',
      Logs: 'Logs',
      Invoice: 'Invoice'
    },
    [BaseEnums.ObjectTypes.Accounts]: {
      Opportunities: 'Opportunities',
      TaskOpen: 'TaskOpen',
      TaskHistory: 'TaskHistory',
      EmailSent: 'EmailSent',
      Attachments: 'Attachments',
      Logs: 'Logs',
      Invoice: 'Invoice'
    },
    [BaseEnums.ObjectTypes.Opportunities]: {
      TaskOpen: 'TaskOpen',
      TaskHistory: 'TaskHistory',
      EmailSent: 'EmailSent',
      Attachments: 'Attachments',
      Logs: 'Logs',
      Invoice: 'Invoice'
    }
  },

  DetailModulesInArray: Object.freeze(_.values(BaseEnums.DetailModules)),

  ColumnsByModule: {
    [BaseEnums.DetailModules.Opportunities]: [
      {
        dataIndex: 'action',
        titleId: `${tableIntl}.action`
      },
      {
        dataIndex: 'target_account_id.id',
        titleId: `${tableIntl}.acctName`
      },
      {
        dataIndex: 'created_at',
        titleId: `${tableIntl}.createDate`
      },
      {
        dataIndex: 'created_by_user_id',
        titleId: `${tableIntl}.createBy`
      },
      {
        dataIndex: 'name',
        titleId: `${tableIntl}.opportName`
      }
    ],
    [BaseEnums.DetailModules.TaskOpen]: [
      {
        dataIndex: 'action',
        titleId: `${tableIntl}.action`
      },
      {
        dataIndex: 'subject',
        titleId: `${tableIntl}.subject`
      },
      {
        dataIndex: 'status_code',
        titleId: `${tableIntl}.status`
      },
      {
        dataIndex: 'priority_code',
        titleId: `${tableIntl}.priority`
      },
      {
        dataIndex: 'due_date',
        titleId: `${tableIntl}.dueOn`
      },
      {
        dataIndex: 'updated_at',
        titleId: `${tableIntl}.lastModifiedAt`
      }
    ],
    [BaseEnums.DetailModules.TaskHistory]: [
      {
        dataIndex: 'subject',
        titleId: `${tableIntl}.subject`
      },
      {
        dataIndex: 'status_code',
        titleId: `${tableIntl}.status`
      },
      {
        dataIndex: 'priority_code',
        titleId: `${tableIntl}.priority`
      },
      {
        dataIndex: 'due_date',
        titleId: `${tableIntl}.dueOn`
      },
      {
        dataIndex: 'updated_at',
        titleId: `${tableIntl}.lastModifiedAt`
      }
    ],
    [BaseEnums.DetailModules.EmailSent]: [
      {
        dataIndex: 'subject',
        titleId: `${tableIntl}.subject`
      },
      {
        dataIndex: 'created_at',
        titleId: `${tableIntl}.sentDate`
      },
      {
        dataIndex: 'open_date',
        titleId: `${tableIntl}.openDate`
      },
      {
        dataIndex: 'open_times',
        titleId: `${tableIntl}.openTimes`
      },
      {
        dataIndex: 'updated_at',
        titleId: `${tableIntl}.lastModifiedAt`
      }
    ],
    [BaseEnums.DetailModules.Attachments]: [
      {
        dataIndex: 'action',
        titleId: `${tableIntl}.action`
      },
      {
        dataIndex: 'category',
        titleId: `${tableIntl}.category`
      },
      {
        dataIndex: 'type',
        titleId: `${tableIntl}.type`
      },
      {
        dataIndex: 'created_at',
        titleId: `${tableIntl}.uploadAt`
      },
      {
        dataIndex: 'created_by',
        titleId: `${tableIntl}.createBy`
      },
      {
        dataIndex: 'comment',
        titleId: `${tableIntl}.comment`
      }
    ],
    [BaseEnums.DetailModules.Logs]: [
      {
        dataIndex: 'updated_at',
        titleId: `${tableIntl}.date`
      },
      {
        dataIndex: 'causer.name',
        titleId: `${tableIntl}.user`
      },
      {
        dataIndex: 'description',
        titleId: `${tableIntl}.action`
      }
    ],
    [BaseEnums.DetailModules.Invoice]: [
      {
        dataIndex: 'action',
        titleId: `${tableIntl}.action`
      },
      {
        dataIndex: 'invoice_no',
        titleId: `${tableIntl}.invoiceNo`
      },
      {
        dataIndex: 'related_to',
        titleId: `${tableIntl}.relatedTo`
      },
      {
        dataIndex: 'status',
        titleId: `${tableIntl}.status`
      },

      {
        dataIndex: 'due_date',
        titleId: `${tableIntl}.dueOn`
      },
      {
        dataIndex: 'last_modified_by_user',
        titleId: `${tableIntl}.modifiedBy`
      },
      {
        dataIndex: 'last_modified_at',
        titleId: `${tableIntl}.lastModifiedAt`
      }
    ]
  },

  MaxDisplayResults: 20,

  FindDupConfigs: Object.freeze({
    BaseFields: Object.freeze([
      'name',
      'lastName',
      'email',
      'company',
      'phone',
      'birthday'
    ]),
    MaxSelection: 4
  }),

  MasterKey: 'master_record_id',

  ScopeTypes: Object.freeze({
    All: 'all',
    Active: 'active',
    Inactive: 'inactive',
  }),

  DateTimeConfigs: Object.freeze({
    // Both belows shoud be consist with format stored in database
    DefaultApiDateFormat: 'YYYY-MM-DD',
    DefaultApiTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    // Following settings are requested in Issue#103 refer to -> http://c7git.acy.svr/LogixCRM/fe_logix_crm/issues/103
    // Both belows are used as default for display
    DefaultDateFormat: 'DD-MM-YYYY',
    DefaultTimeFormat: 'DD-MM-YYYY HH:mm:ss',
    // Used sydney timezone as default for display
    UTCTimezone: 'UTC',
    DefaultTimezone: 'Australia/Sydney',
    DefaultOffset: '+1100',
    DateFormatKey: 'dateFormat',
    TimeFormatKey: 'timeFormat',

    TimeRangePrefix: 'VAR__',

    SubTypes: BaseEnums.DateTimeSubTypes,
    SubTypesInArray: Object.freeze(_.values(BaseEnums.DateTimeSubTypes)),

    Ranges: BaseEnums.DateTimeRanges,
    RangesInArray: Object.freeze(_.values(BaseEnums.DateTimeRanges)),

    PeriodPrefixs: BaseEnums.DateTimePeriodPrefixs,
    PeriodPrefixsInArray: Object.freeze(
      _.values(BaseEnums.DateTimePeriodPrefixs)
    ),

    PeriodTypes: BaseEnums.DateTimePeriodTypes,
    PeriodTypesInArray: Object.freeze(_.values(BaseEnums.DateTimePeriodTypes))
  }),

  Conditions: BaseEnums.Conditions,
  ConditionsInArray: Object.freeze(_.values(BaseEnums.Conditions)),

  EditViewType: Object.freeze({
    ReadOnly: 'readOnly',
    Required: 'required'
  }),

  FileExtensions: Object.freeze({
    Images: '.jpg, .png, .gif, .jpeg',
    Pdf: '.pdf'
  }),

  InvoicePage: Object.freeze({
    ItemsList: Object.freeze({
      Columns: BaseEnums.InvoiceItemsListColumns,
      ColumnsInArray: Object.freeze(_.values(BaseEnums.InvoiceItemsListColumns))
    }),
    Summary: Object.freeze({
      Columns: BaseEnums.InvoiceSummaryColumns,
      ColumnsInArray: Object.freeze(_.values(BaseEnums.InvoiceSummaryColumns)),
      Rows: BaseEnums.InvoiceSummaryRows,
      RowsInArray: Object.freeze(_.values(BaseEnums.InvoiceSummaryRows))
    })
  }),

  DROPZONES: Object.freeze({
    SIDER: 'SIDER',
    GROUPS: 'GROUPS',
    OTHERS: 'OTHERS',
    AGGREGATES: 'AGGREGATES'
  }),

  REPORTS: Object.freeze({
    FORMATS: BaseEnums.REPORT_FORMATS,
    FORMATS_IN_ARRAY: Object.freeze(_.values(BaseEnums.REPORT_FORMATS)),
    SORTER: Object.freeze({
      GROUPSORTER: 'groupAndAggregateSorter',
      ORTHERSSORRTER: 'otherSorter',
    }),
    GROUPS_ZONE_TAG_ACTIONS: Object.freeze([
      'day',
      'week',
      'month',
      'quarter',
      'year'
    ]),
    AGGREGATES_ZONE_TAG_ACTIONS: Object.freeze(['sum', 'avg']),
    PREVIEW: Object.freeze({
      ROWSPERGROUP: 5,
      MAXROWS: 20,
      SUMMARYKEY: '__summary',
      GROUPROWKEY: '__isGroupRow',
      TOTALROWKEY: '__isTotalRow'
    }),
    FOLDER_TYPES: BaseEnums.REPORT_FOLDER_TYPES,
    FOLDER_TYPES_IN_ARRAY: Object.freeze(
      _.values(BaseEnums.REPORT_FOLDER_TYPES)
    ),
    DASHBOARD_DATA_TYPES: Object.freeze([
      'table',
      'pie-chart',
      'bar-chart',
      'line-chart'
    ]),
    DASHBOARD_MAX_SLOTS: 10
  }),

  WEBSOCKET: Object.freeze({
    EVENTS: Object.freeze({
      GENERATE_REPORT: 'ReportGenerated',
      DASHBOARD_REFRESH_FINISHED: 'DashboardRefreshJobFinished',
    }),
    TYPE: Object.freeze({
      DASHBOARD: 'App\\Model\\Dashboard',
      DASHBOARDSLOT: 'App\\Model\\DashboardSlot'
    })
  }),

  WorkFlow: Object.freeze({
    ShortChecker: 'short_checker',
    UserInput: 'user_input',
    FunctionName: 'function',
    ContextAttributes: 'context_attribute',
    ApiEndpoint: 'api_endpoint',
    UpdateFields: 'update_fields',
    Distribution: 'distribution',
    ActionValueType: Object.freeze({
      FILTERVALUE: 'value',
      FIELDID: 'fieldId',
      FUNCTIONTYPE: 'functionType',
      DISTRIBUTIONVALUE: 'distributionValue',
      DISPLAYNUM: 'displayNum',
    })
  })
});

export default EnumsManager;



// WEBPACK FOOTER //
// ./src/utils/EnumsManager.js